import { Link, User } from 'src/components/types';

export type PullRequestLabel = {
  type: string;
  label: Label;
};

export type Label = {
  type: string;
  id: number;
  content: string;
  user: User;
  created_on: string;
  updated_on: string;
  workspace: {
    links: {
      avatar: Link;
      html: Link;
      self: Link;
    };
    name: string;
    slug: string;
    uuid: string;
  };
};
